import { actionCopyFr } from "./actionCopy";

export const diaryCopyFr = {
    diaries: "Journaux",
    diary: "Journal",
    diaryPeriod: "Période du journal",
    toDo: "À faire",
    results: "Résultats",
    toNow: "- Aujourd'hui",
    edit: actionCopyFr.edit,
    change: "Modifier",
    details: "Détails",
    deleteEntry: "Supprimer la saisie",
    done: actionCopyFr.done,
    next: actionCopyFr.next,
    save: actionCopyFr.save,
    saving: actionCopyFr.saving,
    cancel: actionCopyFr.cancel,
    date: "Date",
    time: "Heure",
    noSteps: "Aucune étape.",
    step: "Étape",
    chooseStep: "Choisir une étape",
    currently: "Actuellement",
    general: "Général",
    procedureDetails: "Détails de l'intervention",
    hospitalReferenceNumber: "Numéro de dossier hospitalier",
    hospitalNumber: "Numéro de dossier hospitalier",
    hospitalNumberDescription: "Numéro de dossier hospitalier pour tous les suivis.",
    enterHospitalNumber: "Saisir le numéro de dossier hospitalier",
    startDate: "Date de début",
    procedureDate: "Date de l'intervention",
    referenceDate: "Date de référence",
    referenceDateDescription: "La date de l'injection, de l'opération ou d'une autre intervention.",
    baselineDate: "Date initiale",
    baselineDateDescription:
        "La date à partir de laquelle le suivi est mesuré, par exemple l'inclusion du patient dans l'étude. Les questionnaires sont programmés à partir de cette date.",
    patientBaselineDate: "Date de début",
    patientBaselineDateDescription: "La date à partir de laquelle vos questions de suivi sont programmées.",
    eventDateDescription: "Les questionnaires de suivi sont programmés à partir de cette date.",
    patientEventDateDescription: "Vos questions de suivi sont programmées à partir de cette date.",
    endDate: "Date de fin",
    contactPerson: "Personne de contact",
    contactPersonDescription: "Contact principal pour ce journal. Appuyez sur Copier pour copier son adresse e-mail.",
    loadingContact: "Chargement du contact...",
    side: "Côté",
    anatomicArea: "Zone anatomique",
    questionnaireSide: "Côté du questionnaire",
    questionnaireSideDescription: "Le côté auquel ce questionnaire se rapporte.",
    notSet: "Non défini",
    trackerSettings: "Paramètres du suivi",
    consent: "Consentement",
    consentForm: "Formulaire de consentement",
    consentDetails: "Détails",
    sign: "Signer",
    signed: "Signé",
    signedAt: (date) => `Signé le ${date}`,
    requiresSignature: "Signature requise",
    actionRequiredSignConsent: "Action requise : signer le consentement",
    signConsentBeforeContinuing: (count) =>
        `Vous devez signer ${count > 1 ? "les formulaires de consentement suivants" : "le formulaire de consentement suivant"} avant de continuer :`,
    signConsentNow: "Signer le consentement maintenant",
    detailsStillNeed: "Informations encore nécessaires",
    detailsStillNeedDescription:
        "Veuillez compléter ces informations. Si le côté est toujours manquant, nous vous le demanderons sur l'écran de configuration.",
    injectionSide: "Côté de l'injection",
    injectionAnatomicArea: "Zone anatomique de l'injection",
    surgerySide: "Côté de l'opération",
    shockwaveSide: "Côté des ondes de choc",
    shockwaveAnatomicArea: "Zone anatomique des ondes de choc",
    yourEntries: "Vos saisies",
    noDiary: "Aucun journal",
    noCompletedEntries: "Aucune saisie terminée pour le moment.",
    form: "formulaire",
    forms: "formulaires",
    item: "élément",
    items: "éléments",
    questionnaire: "Questionnaire",
    questionnaires: "Questionnaires",
    injection: "Injection",
    surgery: "Opération",
    shockwave: "Ondes de choc",
    consultation: "Consultation",
    procedure: "Intervention",
    procedures: (count) => `${count} interventions`,
    task: "tâche",
    tasks: "tâches",
    toDoEmpty: "Vous êtes à jour - rien à faire pour le moment.",
    blocked: "En attente de formulaires précédents",
    blockedEmpty: "Aucun formulaire n'attend d'étapes précédentes.",
    formsLockedUntilConsentSigned: "Vos formulaires seront débloqués après la signature du consentement requis.",
    completePreviousFormFirst: (formName) => `Complétez d'abord ${formName}`,
    doneEmpty: "Les étapes terminées apparaîtront ici.",
    complete: "Terminé",
    due: "À faire",
    upToDate: "À jour",
    allCaughtUp: "Tout est à jour",
    formsNeedAttention: "Formulaires à traiter",
    progress: "Progression",
    completed: "Terminé",
    notNeeded: "Non nécessaire",
    dueNow: "À faire maintenant",
    waiting: "En attente",
    locked: "Verrouillé",
    lockedByEarlierEntry: "Verrouillé - complétez d'abord une saisie précédente",
    lockedUntilPreviousFormComplete: (formName) => `Verrouillé - complétez d'abord ${formName}`,
    availableLater: "Disponible plus tard",
    nextDue: "Prochaine échéance",
    dueOn: (date) => `À faire le ${date}`,
    nextScheduledSentence: (formLabel, scheduleLabel, date) => {
        const schedule = scheduleLabel.trim();
        const due = date.trim();
        const timing = schedule ? ` pour ${schedule.toLowerCase()}` : "";
        if (due) return `Votre ${formLabel}${timing} est à effectuer le ${due}.`;
        return `Votre ${formLabel}${timing} est à effectuer prochainement.`;
    },
    noEntriesScheduled: "Aucune saisie planifiée pour le moment.",
    showLess: "Afficher moins",
    showMore: (count) => `Afficher plus (${count} ${count === 1 ? "échéance" : "échéances"} de plus)`,
    showAllTimings: (count) => `Afficher les ${count} échéances`,
    expand: "Développer",
    submitted: (completed, total) => `${completed} sur ${total} envoyé(s)`,
    submittedOn: (date) => `Envoyé le ${date}`,
    noDataYet: "Aucune donnée pour le moment",
    noDataDescription: "Commencez à ajouter des saisies pour voir votre progression dans le temps",
    notEnoughDataYet: "Pas encore assez de données",
    notEnoughDataDescription: "Pour afficher des graphiques, il faut au moins deux saisies.",
    addEntry: "Ajouter une saisie",
    addEntryFor: (formSlug, timingLabel) => `Ajouter une saisie ${formSlug} ${timingLabel}`,
    addExtraScore: "Ajouter un score supplémentaire",
    addExtraScoreTitle: "Ajouter un score supplémentaire",
    addExtraScoreDescription:
        "Cette étape est facultative. Continuez uniquement si vous souhaitez enregistrer une mesure supplémentaire, ou si l'on vous a demandé de faire un point.",
    addForm: "Ajouter un formulaire",
    entryDue: (label) => `Votre saisie pour ${label.toLowerCase()} est à effectuer.`,
    nextEntryDueOn: (label, date) => `Votre saisie « ${label.toLowerCase()} » est à effectuer le ${date}.`,
    entriesDueForForm: (count) => `${count} saisies à effectuer pour ce formulaire.`,
    formWithEntriesDue: (formName, entries) =>
        `${formName} comporte ${entries} ${entries === 1 ? "saisie à effectuer" : "saisies à effectuer"}. Vos autres formulaires sont à jour.`,
    formsWithEntriesDue: (forms, entries) =>
        `Vous avez ${forms} ${forms === 1 ? "formulaire" : "formulaires"} avec ${entries} ${
            entries === 1 ? "saisie à effectuer" : "saisies à effectuer"
        }.`,
    allFormsComplete: "Tous vos formulaires sont terminés.",
    allEntriesComplete: "Toutes les saisies sont terminées",
    entriesDueNow: (count) => `${count} saisies à effectuer maintenant`,
    completeYourEntry: (label) => `Complétez votre saisie « ${label.toLowerCase()} »`,
    questionnaireDueNow: "Questionnaire à remplir maintenant",
    nextEntryLabel: (label) => `Prochaine saisie : ${label}`,
    waitingForNextEntry: "En attente de la prochaine saisie",
    readyLabel: (label) => `Prêt : ${label}`,
    readyToComplete: "Prêt à être rempli",
    reminderText: "Nous vous enverrons un SMS lorsque ce sera à faire.",
    reminderEmail: "Nous vous enverrons un e-mail lorsque ce sera à faire.",
    reminderTextAndEmail: "Nous vous enverrons un SMS et un e-mail lorsque ce sera à faire.",
    reminderNone:
        "Activez les rappels par SMS ou par e-mail dans vos paramètres si vous souhaitez un rappel au moment voulu.",
    entrySubmitted: "Saisie transmise.",
    completeWithCareTeam: "Terminé et en attente d'examen.",
    formNumber: (index) => `Formulaire n° ${index}`,
    dateOfProcedure: (phrase) => `Date de l'intervention (${phrase})`,
    wrongDate: "Mauvaise date ?",
    editHere: "Modifier ici",
    showAnswers: "Afficher les réponses",
    hideAnswers: "Masquer les réponses",
    showAnswersDescription:
        "Consultez les réponses ou appuyez sur Modifier sur une échéance pour mettre à jour les réponses",
    entryCountLabel: (count) => (count === 1 ? "1 saisie" : `${count} saisies`),
    timing: "Échéance",
    referredBy: (name) => `Adressé par : ${name}`,
    performedBy: (name) => `Réalisé par : ${name}`,
    method: (method) => `Méthode : ${method}`,
    injectionDetails: "Informations sur l'injection",
    unknown: "Inconnu",
    noDateSpecified: "Aucune date indiquée",
    noInjectionDetails: "Aucune information sur l'injection fournie.",
    sideNotSpecified: "Côté non précisé",
    areaNotSpecified: "Zone non précisée",
    siteNotSpecified: "Site non précisé",
    substanceNotSpecified: "Substance non précisée",
    blankAnswer: "Laissé vide",
    listEmptyTitle: "Aucun journal pour le moment",
    listEmptyDescription: "Les journaux créés pour vous apparaissent ici",
    listCheckAgain: "Vérifier à nouveau",
    listNeedsAttention: "Nécessite votre attention",
    listNeedsAttentionDescription: "Journaux dont les formulaires attendent votre prochaine saisie.",
    listOngoing: "En cours",
    listOngoingDescription: "Journaux en cours ou en attente de votre première saisie.",
    listUpToDateDescription: "Journaux en cours sans saisie à effectuer pour le moment.",
    listNoOngoing: "Aucun journal en cours pour le moment",
    listCompletedDescription: "Journaux terminés (qui ne collectent plus de saisies).",
    listNoCompleted: "Aucun journal terminé pour le moment",
    listOpenDiary: "Ouvrir le journal",
    listReviewDiary: "Consulter le journal",
};
